export interface RobotInterface {
  code: string;
  name: string;
  status: 'UNSTART' | 'START' | 'PAUSE' | 'CONTINUE' | 'END'
}

export const RobotStatusMap = {
  UNSTART: '未开始',
  START: '进行中',
  PAUSE: '已暂停',
  CONTINUE: '进行中',
  END: '已结束',
}
